export const DICTIONARY = {
  some: {
    en: () => '',
    ru: () => '',
  },
  howToSell: {
    en: () => 'How to sell the Username',
    ru: () => 'Как продать никнэйм',
  },
  howToBuy: {
    en: () => 'How to buy Usernames',
    ru: () => 'Как купить никнэйм',
  },
  attemptsCount: {
    en: () => 'attempts count',
    ru: () => 'кол-во attempts',
  },
  setAttemptsAmount: {
    en: () => 'Set the amount of Attempts you want to buy',
    ru: () => 'Укажите количество Attempts, что хотите купить',
  },
  yourUsername: {
    en: () => 'Your username:',
    ru: () => 'Ваш никнейм:',
  },
  freeAttempts: {
    en: () => 'Fragment at the beginning always gifts 3 free buying attempts. Buy new attempts only if you have spent them',
    ru: () => 'Fragment в начале всегда дарит 3 бесплатные Attempts для покупки. Купите новые Attempts только в случае, если вы их потратили',
  },
  buyingAttempts: {
    en: () => 'Buying Attempts',
    ru: () => 'Покупка Attempts',
  },
  activateUsernameTitle: {
    en: () => 'Activate your Username to be able to buy Telegram Assets',
    ru: () => 'Активируйте свой Никнейм, чтобы иметь возможность покупать активы Telegram',
  },
  activateUsernameInfo: {
    en: () => 'For buying Phone Numbers or new Usernames in Fragment you need to have an activated username. Here you can activate your Username',
    ru: () => 'Для покупки номеров или новых никнеймов в Fragment Вам необходимо иметь активированный никнейм. Здесь вы можете активировать свой никнейм',
  },
  addresses: {
    en: () => 'Addresses:',
    ru: () => 'Адреса:',
  },
  contactUsername: {
    en: () => 'contact username',
    ru: () => 'никнейм',
  },
  wrongWalletAddress: {
    en: () => 'Wrong wallet address',
    ru: () => 'Неверный адрес кошелька',
  },
  setWalletAddress: {
    en: () => 'Set your wallet address',
    ru: () => 'Укажите адрес кошелька',
  },
  setTelegramUsername: {
    en: () => 'Set your Telegram Username',
    ru: () => 'Укажите Ваш никнейм Telegram',
  },
  toReceiveTonCoins: {
    en: () => 'To receive TON coins, you must activate your wallets within our system. Activation ensures your wallet is registered and ready to securely handle transactions. This step enables us to synchronize your wallet with our platform, granting you access to manage your TON assets seamlessly. By doing this, we can maintain better control over the distribution process, ensuring a smooth and efficient transfer of coins. Without activation, your wallet cannot receive TON coins or interact with our system. Take a moment to complete the activation process and unlock the full potential of our platform for managing your TON tokens effectively.',
    ru: () => 'Чтобы получить монеты TON, вам необходимо активировать свои кошельки в нашей системе. Активация гарантирует, что ваш кошелек зарегистрирован и готов к безопасной обработке транзакций. Этот шаг позволяет нам синхронизировать ваш кошелек с нашей платформой, предоставляя вам доступ к бесперебойному управлению вашими активами TON. Благодаря этому мы можем лучше контролировать процесс распределения, обеспечивая плавную и эффективную передачу монет. Без активации ваш кошелек не сможет получать монеты TON или взаимодействовать с нашей системой. Уделите немного времени, чтобы завершить процесс активации и раскрыть весь потенциал нашей платформы для эффективного управления вашими токенами TON.',
  },
  generateTransaction: {
    en: () => 'Generate Transaction',
    ru: () => 'Создать транзакцию',
  },
  selectContactUsername: {
    en: () => 'Set your Telegram Username how we can contact to you:',
    ru: () => 'Укажите Ваш никнейм в Telegram, по которому мы сможем связаться с Вами:',
  },
  selectAddressOne: {
    en: () => 'Select your wallet\'s address:',
    ru: () => 'Укажите адрес Вашего кошелька:',
  },
  selectAddressMany: {
    en: () => 'Select your wallet\'s addresses separated by comma:',
    ru: () => 'Укажите адреса Ваших кошельков, разделенные запятыми:',
  },
  select: {
    en: () => 'Select',
    ru: () => 'Выбрать',
  },
  wallet: {
    en: () => 'wallet',
    ru: () => 'кошелек',
  },
  wallets: {
    en: () => 'wallets',
    ru: () => 'кошелька',
  },
  wallets2: {
    en: () => 'wallets',
    ru: () => 'кошельков',
  },
  for: {
    en: () => 'for',
    ru: () => 'за',
  },
  youCanActivate: {
    en: () => 'You can activate',
    ru: () => 'Вы можете активировать',
  },
  chooseYourPlan: {
    en: () => 'Choose your plan',
    ru: () => 'Выберите ваш тариф',
  },
  activateYourWalletInfo: {
    en: () => 'For receiving TON coins in Fragment you need to have an activated wallet. Here you can activate your wallets.',
    ru: () => 'Для получения монет TON в Fragment вам необходимо иметь активированный кошелек. Здесь вы можете активировать свои кошельки.',
  },
  activateYourWallet: {
    en: () => 'Activate your Wallet and receive TON coins',
    ru: () => 'Активируйте свой кошелек и получите монеты TON',
  },
  number: {
    en: () => 'number',
    ru: () => 'номер',
  },
  numberCanBe: {
    en: () => 'This anonymous number can be used to create a Telegram account not tied to a SIM card.',
    ru: () => 'Этот анонимный номер можно использовать для создания учетной записи Telegram, не привязанной к SIM-карте.',
  },
  numberNotInList: {
    en: () => 'This phone number is not in our list.',
    ru: () => 'Этот номер не находится в нашем списке.',
  },
  hereYouCanNumbers: {
    en: () => 'Here you can make an offer to the phone number owner to buy it.',
    ru: () => 'Здесь вы можете сделать предложение владельцу номера телефона о его покупке.',
  },
  anonymousNumbers: {
    en: () => 'Anonymous number',
    ru: () => 'Анонимные номера',
  },
  topNumbersForSale: {
    en: () => 'Top Numbers for Sale',
    ru: () => 'Лучшие номера на продаже',
  },
  buyAndSellNumbers: {
    en: () => 'Buy and Sell Anonymous Numbers',
    ru: () => 'Покупать и продавать анонимные номера',
  },
  buyAndSellNumbersInfo: {
    en: () => 'Trade IDs not tied to a SIM card which allow logging into Telegram with your blockchain account. These numbers only work on Telegram.',
    ru: () => 'Торговые идентификаторы, не привязанные к SIM-карте, которые позволяют войти в Telegram с помощью вашего блокчейн аккаунта. Эти номера работают только в Telegram.',
  },
  usernames: {
    en: () => 'Usernames',
    ru: () => 'Никнеймы',
  },
  username: {
    en: () => 'Username',
    ru: () => 'Никнейм',
  },
  numbers: {
    en: () => 'Numbers',
    ru: () => 'Номера',
  },
  tutorials: {
    en: () => 'Tutorials',
    ru: () => 'Обучение',
  },
  activateWallet: {
    en: () => 'Activate Wallet',
    ru: () => 'Активировать Кошелек',
  },
  activateUsername: {
    en: () => 'Activate Username',
    ru: () => 'Активировать Никнейм',
  },
  contactUs: {
    en: () => 'Contact Us',
    ru: () => 'Поддержка',
  },
  buyAndSell: {
    en: () => 'Buy and Sell Usernames',
    ru: () => 'Покупать и продавать Никнеймы',
  },
  buyAndSellInfo: {
    en: () => 'Secure your name with blockchain in an ecosystem of 950+ million users and assign it as a link for your personal account, channel or group.',
    ru: () => 'Защитите свое имя с помощью блокчейна в экосистеме из более чем 950 миллионов пользователей и назначьте его в качестве ссылки для своей личной учетной записи, канала или группы.',
  },
  buyAndSellInput: {
    en: () => 'Enter a Telegram username...',
    ru: () => 'Введите никнейм в Telegram...',
  },
  learn: {
    en: () => 'Learn',
    ru: () => 'Узнать больше',
  },
  forSale: {
    en: () => 'For Sale',
    ru: () => 'На продаже',
  },
  minimalPrice: {
    en: () => 'Minimal price',
    ru: () => 'Минимальная цена',
  },
  topAuctions: {
    en: () => 'Top Auctions',
    ru: () => 'Топ предложения',
  },
  about: {
    en: () => 'About',
    ru: () => 'О нас',
  },
  terms: {
    en: () => 'Terms',
    ru: () => 'Политика',
  },
  privacy: {
    en: () => 'Privacy',
    ru: () => 'Безопасность',
  },
  hereYouCan: {
    en: () => 'Here you can make an offer to the username owner to buy it.',
    ru: () => 'Здесь вы можете сделать предложение владельцу никнейма о его покупке.',
  },
  thisIsJustPrice: {
    en: () => 'This is just a price the owner has temporarily set for this username. You can offer any amount you want.',
    ru: () => 'Это просто цена, которую владелец временно установил для этого никнейма. Вы можете предложить любую сумму, которую хотите.',
  },
  thisIsJustPriceNumber: {
    en: () => 'This is just a price the owner has temporarily set for this number. You can offer any amount you want.',
    ru: () => 'Это просто цена, которую владелец временно установил для этого номера. Вы можете предложить любую сумму, которую хотите.',
  },
  newOwner: {
    en: () => 'Your username (new owner)',
    ru: () => 'Ваш никнейм (новый владелец)',
  },
  telegramUsername: {
    en: () => 'Telegram username',
    ru: () => 'Никнейм в Telegram',
  },
  webAddress: {
    en: () => 'Web address',
    ru: () => 'Web адрес',
  },
  web3Address: {
    en: () => 'TON Web 3.0 Address',
    ru: () => 'TON Web 3.0 адрес',
  },
  usernameNotFound: {
    en: () => 'Username not found',
    ru: () => 'Никнейм не найден',
  },
  youHave3: {
    en: () => 'You have 3 free buying attempts',
    ru: () => 'У вас есть 3 бесплатные Attempts для покупки',
  },
  sendOffer: {
    en: () => 'Send offer',
    ru: () => 'Отправить предложение',
  },
  minimum15: {
    en: () => 'Minimum 15 TON',
    ru: () => 'Минимум 15 TON',
  },
  transactionCreated: {
    en: () => 'Transaction successfully created!',
    ru: () => 'Транзакция была успешно создана!',
  },
  nowYouCanTransfer: {
    en: () => 'Now you can transfer the amount of TON you have set',
    ru: () => 'Теперь Вы можете перевести количество TON, что вы указали',
  },
  thisUserHasNot: {
    en: () => 'This user hasn\'t set his username for sale yet.',
    ru: () => 'Этот пользователь пока не выставил имя своего пользователя на продажу.',
  },
  price: {
    en: () => 'price',
    ru: () => 'цена',
  },
  newOwnerSmall: {
    en: () => 'new owner',
    ru: () => 'новый владелец',
  },
  transfer: {
    en: () => 'Transfer',
    ru: () => 'К оплате',
  },
};
